// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__i5jTK","dragIcon":"SortableItem_dragIcon__1rat2","disabled":"SortableItem_disabled__PscCI"};